import axios from 'axios'
import cookie from 'js-cookie'
import appVersion from './_app_version.js'
import { ParentBridge } from 'vk-hybrid'
import { logout } from './_redirect'
import { clearStorage } from '@/utils'

const requestFunc = function req () {
  const instance = axios.create({
    timeout: 10000,
    responseType: 'json'
  })

  instance.interceptors.request.use((config) => {
    const Authorization = cookie.get('Authorization')
    if (Authorization) {
      config.headers.Authorization = Authorization
    }
    return config
  }, error => Promise.reject(error))

  instance.interceptors.response.use((response) => {
    if (response.status === 200) {
      return response.data
    }
    return Promise.reject(response.data)
  }, error => {
    if (error.response && error.response.status === 401) {
      if (appVersion.isApp) {
        return ParentBridge.userLogin({
          phone: '',
          loginType: 'pwd'
        }).then(data => {
          if (data && data.data && data.data.state === 'success') {
            window.location.reload()
          } else {
            ParentBridge.userLogout({
              phone: '',
              loginType: 'pwd'
            })
          }
        }).catch(() => {
          ParentBridge.userLogout({
            phone: '',
            loginType: 'pwd'
          })
        })
      } else {
        clearStorage()
        window.location.href = logout()
        return
      }
    }
    return Promise.reject(error)
  })

  return instance
}

const request = requestFunc()

export default request
